module.exports = __webpack_public_path__ + "assets/img/order_9.4d779515.svg";